// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { useAuthStore } from "@/stores/auth.store";
import {getConfig} from "@/config/config";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// Initialize Firebase
const config = getConfig()
const app = initializeApp(config.FIREBASE_CONFIG);
const analytics = getAnalytics(app);
analytics;
const auth = getAuth(app);

if (config.BACKEND_ENDPOINT.includes("localhost")) {
  console.warn("###### USING AUTHENTICATION WITH EMULATOR #####")
  connectAuthEmulator(auth, "http://localhost:9099");
}

auth.onAuthStateChanged((user) => {
  const authStore = useAuthStore()

  if (user) {
    authStore.setUser(user);
  } else {
    authStore.setUser(null);
  }
});
